export default __webpack_public_path__ + "static/media/forestly-expl-01_DE.8a00ff39.png";